"use strict";

/**
 * Storage-Typen
 * @enum {int}
 */
gc.gis.GCStorageType = {
    /**
     * Speichertyp Lokaler-Speicher
     * @type {int}
     */
    LOCAL_STORAGE	: 0,
    /**
     * Speichertyp Session-Speicher
     * @type {int}
     */
    SESSION_STORAGE : 1,
    /**
     * Speichertyp Cookie.
     * @type {int}
     */
    COOKIE 			: 2
};

/**
 *	Statische Klasse mit Hilfsfunktionen für den Zugriff auf die Session, den LocalStorage und den SessionStorage.
 *
 *	@class
 *	@static
 *	@author	Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.GCStorage = {

    bLocalStorage	: ('localStorage' in window),
    bSessionStorage : ('sessionStorage' in window),
    bCookieStorage  : ('cookie' in document),

    /**
     * Liest einen Wert aus dem angegebenen Speicherbereich.
     *
     * @public
     * @param {string} key Schlüssel des gespeicherten Werts
     * @param {int} type Speicherbereich in dem der Wert gesucht werden soll
     * @param {string} [default_value=undefined] Standardwert, der zurückgegeben wird, wenn kein passender Eintrag im
     *                          angegeben Speicherbereich gefunden wurde
     * @return {string}
     */
    getItem : function(key, type, default_value)
    {
        var item = '';
        if( typeof type === 'undefined' )
        {
            type = GeoCMS.Storage.StorageType.LOCAL;
        }

        if (type === GeoCMS.Storage.StorageType.LOCAL)
        {
            if ('GeoCMSLocalStorage' in window)
            {
                item = window.GeoCMSLocalStorage.getItem(key);
            }
            else if (this.bLocalStorage)
            {
                item = window.localStorage.getItem(key);
            }
        }
        else if (type === GeoCMS.Storage.StorageType.SESSION)
        {
            if ('GeoCMSSessionStorage' in window)
            {
                item = window.GeoCMSSessionStorage.getItem(key);
            }
            else if (this.bSessionStorage)
            {
                item = window.sessionStorage.getItem(key);
            }
        }
        else if (this.bCookieStorage && type === GeoCMS.Storage.StorageType.COOKIE) {
            item = this._getCookie(key);
        }

        return (item !== 'undefined' && item !== null) ? item : default_value;
    },

    /**
     * Schreibt einen Wert in den angegebenen Speicherbereich.
     *
     * @public
     * @param {string} key Schlüssel des zu speichernden Werts
     * @param {string} value der zu speichernde Wert
     * @param {int} type Speicherbereich in dem der Wert gespeichert werden soll
     * @return {boolean} Flag, ob der Speicherung erfolgreich war
     */
    setItem : function(key, value, type)
    {
        var ret = true;

        if(typeof type === 'undefined')
        {
            type = GeoCMS.Storage.StorageType.LOCAL;
        }

        if ([GeoCMS.Storage.StorageType.LOCAL, GeoCMS.Storage.StorageType.SESSION, GeoCMS.Storage.StorageType.COOKIE].includes(type))
        {
            GeoCMS.Storage.setItem(key, value, type);
        }
        else
        {
            ret = false;
        }

        return ret;
    },

    /**
     * Löscht einen Wert aus dem angegebenen Speicherbereich.
     *
     * @public
     * @param {string} key Schlüssel des gespeichernden Werts
     * @param {int} [opt_type] Speicherbereich in dem der Wert gespeichert ist
     * @return {boolean} Flag, ob das Löschen erfolgreich war
     */
    removeItem : function(key, opt_type)
    {
        var ret = true;

        if (typeof opt_type === 'undefined')
        {
            opt_type = GeoCMS.Storage.StorageType.LOCAL;
        }

        if ([GeoCMS.Storage.StorageType.LOCAL, GeoCMS.Storage.StorageType.SESSION, GeoCMS.Storage.StorageType.COOKIE].includes(opt_type))
        {
            GeoCMS.Storage.removeItem(key, opt_type);
        }
        else
        {
            ret = false;
        }

        return ret;
    },

    /**
     * Gibt den Wert eines HTML-Cookies zurück oder <code>undefined</code>, sofern kein passender Eintrag gefunden wurde.
     *
     * @param {String} key
     * @returns {String|undefined}
     */
    _getCookie: function(key)
    {
        return GeoCMS.Cookie.getCookie(key);
    },

    /**
     * Setzt den Wert eines HTML-Cookies.
     *
     * @private
     * @param {String} key
     * @param {String} value
     * @param {String|Date|Number} [expiration]
     * @param {String} [path]
     * @param {String} [domain]
     * @param {boolean} [secure]
     * @returns {boolean}
     */
    _setCookie: function(key, value, expiration, path, domain, secure)
    {
        return GeoCMS.Cookie.setCookie(key, value, expiration, path, domain, secure);
    },

    /**
     * Löscht den Wert eines HTML-Cookies.
     *
     * @private
     * @param {String} key
     */
    _removeCookie : function(key)
    {
        GeoCMS.Cookie.removeCookie(key);
    }
};